import React, { memo } from "react";
import { CalculatorProvider } from "./state/calculatorContext";
import MatrixView from "./components/MatrixView";

const CalculatorContainer = (props) => {
  return (
    <CalculatorProvider>
      <MatrixView {...props} />
    </CalculatorProvider>
  );
};

export default memo(CalculatorContainer);
